import * as types from './types'

const initialState = {
    tahunConfig: {
        loadingGet: false,
        errorGet: false,
        messageGet: "",
        yearlist: null,
        year: null,
    },
}

export default function settingsReducer(state = initialState, actions){
    switch(actions.type){
        case types.GET_TAHUNCONFIG_START:
            return {
                ...state,
                tahunConfig: {
                    ...state.tahunConfig,
                    loadingGet: true,
                    errorGet: false,
                    messageGet: "loading"
                }
            }
        case types.GET_TAHUNCONFIG_SUCCESS:
            return {
                ...state,
                tahunConfig: {
                    ...state.tahunConfig,
                    loadingGet: false,
                    errorGet: false,
                    messageGet: actions.payload.message,
                    yearlist: actions.payload.result.yearlist,
                    year: actions.payload.result.year,
                }
            }
        case types.GET_TAHUNCONFIG_FAILED:
            return {
                ...state,
                tahunConfig: {
                    ...state.tahunConfig,
                    loadingGet: false,
                    errorGet: true,
                    messageGet: actions.payload.message,
                    yearlist: null,
                    year: null,
                }
            }
        default:
            return state;
    }
}